import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import logo from "../image/logonav.png";
import refresh from "../image/refresh_icon.png";
import "../css/Nav.css";
import axios from "axios";
import { alpha, styled } from "@mui/material/styles";
import { toast } from "react-toastify";
import { pink } from "@mui/material/colors";
import Switch from "@mui/material/Switch";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import BellIcon from "../image/bell-icon.png";
import InboxIcon from "@mui/icons-material/Inbox";
import RefreshIcon from "@mui/icons-material/Refresh";

import {
  Badge,
  Box,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // ✅ General success
import CancelIcon from "@mui/icons-material/Cancel"; // ❌ Denied/Rejected
import LoopIcon from "@mui/icons-material/Loop"; // 🔄 In Progress
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"; // 💰 Payment related
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty"; // ⏳ Awaiting
import AssignmentIcon from "@mui/icons-material/Assignment"; // 📄 Request-related
import EngineeringIcon from "@mui/icons-material/Engineering"; // 👷 Inspector Assigned
import TaskIcon from "@mui/icons-material/Task"; // ✅ Completed/Closed
import GavelIcon from "@mui/icons-material/Gavel"; // 🏗️ Project-related
import DoneAllIcon from "@mui/icons-material/DoneAll"; // ✅ Approved
import ErrorIcon from "@mui/icons-material/Error"; // ⚠️ Rejected
import InfoIcon from "@mui/icons-material/Info";
import {
  CheckCircle,
  Cancel,
  HourglassEmpty,
  AttachMoney,
  Assignment,
  Task,
  Gavel,
  Engineering,
  Info,
  DoneAll,
  Error,
} from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
function NavBar() {
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  const navigate = useNavigate();
  const [genAI, setGenAI] = useState(false);
  const userdata = JSON.parse(localStorage.getItem("userData"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [notificationsData, setNotificationData] = useState([]);

  // useEffect(() => {
  //   const checkSession = async () => {
  //     try {
  //       const response = await axios.get("/cvault/check-session/");
  //       if (response.data.message !== "Session active") {
  //         handleLogout();
  //       } else {
  //         console.log("====================================");
  //         console.log("Session Active");
  //         console.log("====================================");
  //       }
  //     } catch (error) {
  //       console.error("Session check failed:", error);
  //       handleLogout();
  //     }
  //   };

  //   // Check session every 5 minute
  //   // const interval = setInterval(checkSession, 2000);
  //   const notificationInterval = setInterval(getNotifications, 2000);

  //   // Initial session check on mount
  //   // checkSession();
  //   getNotifications();

  //   return () => {
  //     // clearInterval(interval);
  //     clearInterval(notificationInterval);
  //   }; // Cleanup interval when unmounted
  // }, [navigate]);

  useEffect(() => {
    const checkUserDatas = () => {
      if (window.location.pathname) {
        const userdata = JSON.parse(localStorage.getItem("userData"));

        if (!userdata) {
          handleLogout();
        } else {
          const isLogin = Boolean(cookies.sessionid);
          if (!isLogin) {
            handleLogout();
          }
        }
      }
    };

    // Run on component mount
    checkUserDatas();

    // Run every 1/2 seconds
    const interval = setInterval(checkUserDatas, 500);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getNotifications();
  }, [window.location.pathname]);

  const getNotifications = async () => {
    try {
      const res = await axios.get("/cvault/notification/", {
        headers: headers,
      });
      setNotifications(
        res?.data?.notifications.filter((v) => !v?.is_deleted) || []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const notificationRead = async (id) => {
    try {
      const res = await axios.put(
        "/cvault/notification-read/",
        { notification_id: id },
        {
          headers: headers,
        }
      );
      getNotifications();
    } catch (error) {
      console.log(error);
    }
  };

  const notificationDelete = async (id) => {
    try {
      const res = await axios.put(
        "/cvault/notification-delete/",
        { notification_ids: id },
        {
          headers: headers,
        }
      );
      getNotifications();
    } catch (error) {
      console.log(error);
    }
  };

  const getIcon = (status, isRead) => {
    if (!status) return <Info color="disabled" />; // Handle empty cases

    status = status.toLowerCase(); // Convert to lowercase for case-insensitive matching

    if (status.includes("project creation"))
      return <VerifiedIcon color={isRead ? "disabled" : "success"} />;
    if (status.includes("change request"))
      return <Assignment color={isRead ? "disabled" : "info"} />;
    if (
      status.includes("payment initiated") ||
      status.includes("contractor payment initiate")
    )
      return <AttachMoney color={isRead ? "disabled" : "warning"} />;
    if (
      status.includes("awaiting payment") ||
      status.includes("contractor payment awaiting")
    )
      return <HourglassEmpty color={isRead ? "disabled" : "warning"} />;
    if (status.includes("payment accepted"))
      return <CheckCircle color={isRead ? "disabled" : "success"} />;
    if (status.includes("change request accepted"))
      return <DoneAll color={isRead ? "disabled" : "success"} />;
    if (status.includes("change request denied"))
      return <Cancel color={isRead ? "disabled" : "error"} />;
    if (status.includes("inspection request"))
      return <Engineering color={isRead ? "disabled" : "info"} />;
    if (status.includes("inspector assigned"))
      return <Task color={isRead ? "disabled" : "primary"} />;
    if (status.includes("inspector completed"))
      return <CheckCircle color={isRead ? "disabled" : "success"} />;
    if (
      status.includes("inspection report accept by owner") ||
      status.includes("inspection report accept by contractor")
    )
      return <DoneAll color={isRead ? "disabled" : "success"} />;
    if (
      status.includes("inspection report reject by owner") ||
      status.includes("inspection report reject by contractor")
    )
      return <Error color={isRead ? "disabled" : "error"} />;
    if (
      status.includes("milestone closed") ||
      status.includes("project closed")
    )
      return <Task color={isRead ? "disabled" : "secondary"} />;

    return <Info color={isRead ? "disabled" : "success"} />; // Default icon
  };

  const [notifications, setNotifications] = useState(notificationsData);

  const handleLogout = async () => {
    try {
      var data = await axios.get(`/cvault/logout`, {
        withCredentials: true,
      });
      document.cookie =
        "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie =
        "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      localStorage.removeItem("userData");
      navigate("/login");
    } catch (error) {
      document.cookie =
        "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie =
        "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      localStorage.removeItem("userData");
      navigate("/login");
    }
  };

  const label = { inputProps: { "aria-label": "Color switch demo" } };

  const handleChange = async (event) => {
    try {
      setGenAI(event.target.checked);
      await axios.post(
        "/cvault/genai-status/",
        {
          genai_status: event.target.checked ? "Active" : "Deactive",
        },
        {
          headers: headers,
        }
      );
      toast.success("GenAI status updated successfully");
    } catch (error) {
      toast.error("Please try again later");
      setGenAI(!event.target.checked);
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClearAll = () => {
    notificationDelete(notifications.map((notification) => notification?.id));
    setNotifications([]);
  };
const handleNotificationClick = (notification) => {
  const user = JSON.parse(localStorage.getItem("userData"));
  let targetPath = user?.role?.toLowerCase(); // default path

  if (notification?.type === "New User Registered") {
    targetPath = "viewusers"; // override for new user notifications
  }

  // Clear the state before setting new values
  navigate(`/${targetPath}`, { replace: true, state: {} });

  // After clearing, set the new state
  handleClose();
  setTimeout(() => {
    navigate(`/${targetPath}`, {
      state: {
        notification: notification,
      },
    });
  }, 0);
};


  const handleClose = () => {
    setOpen(false);
    getNotifications();
  };
  const checkUserData = () => {
    if (window.location.pathname == "/") {
      var userdata = JSON.parse(localStorage.getItem("userData"));
      if (userdata?.role == "Admin") {
        window.location.href = "/admin";
      } else if (userdata?.role == "Owner") {
        window.location.href = "/owner";
      } else if (userdata?.role == "Contractor") {
        window.location.href = "/contractor";
      } else {
        window.location.href = "/login";
      }
    }
  };

  const getGenAI = async () => {
    if (userdata?.role === "Admin") {
      try {
        var pData = await axios.get("/cvault/genai-status/");
        const isGenAIActive = pData?.data?.genai_status === "Active";
        setGenAI(isGenAIActive);
      } catch (error) {
        toast.error("Please try again later");
      }
    }
  };

  useEffect(() => {
    checkUserData();
    getGenAI();
  }, []);

  const getRelativeTime = (dateString) => {
    // Parse the date string assuming it's in UTC
    const [day, month, year, hour, minute, second, period] = dateString
      .match(/(\d+)-(\d+)-(\d+)\s+(\d+):(\d+):(\d+)\s+(AM|PM)/)
      .slice(1);

    // Convert to 24-hour format
    const hours24 =
      period === "AM"
        ? hour === "12"
          ? 0
          : parseInt(hour)
        : hour === "12"
        ? 12
        : parseInt(hour) + 12;

    // Create a UTC Date object
    const pastUTC = new Date(
      Date.UTC(year, month - 1, day, hours24, minute, second)
    );

    // Convert to local time
    const pastLocal = new Date(
      pastUTC.toLocaleString("en-US", {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    );

    const now = new Date();

    const diffInSeconds = Math.floor((now - pastLocal) / 1000);

    if (diffInSeconds < 60) {
      return "Just now";
    } else if (diffInSeconds < 3600) {
      return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    } else if (diffInSeconds < 86400) {
      return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    } else {
      return `${Math.floor(diffInSeconds / 86400)} days ago`;
    }
  };

  function getLastRefreshTime() {
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(new Date());

    const month = parts.find((p) => p.type === "month").value;
    const day = parts.find((p) => p.type === "day").value;
    const year = parts.find((p) => p.type === "year").value;
    const hour = parts.find((p) => p.type === "hour").value;
    const minute = parts.find((p) => p.type === "minute").value;
    const period = parts
      .find((p) => p.type === "dayPeriod")
      .value.toUpperCase();

    return `Last Refresh: ${month}-${day}-${year} ${hour}:${minute} ${period}`;
  }

  return (
    <>
      <nav
        className="navbar navbar-expand-xl bg-body-tertiary  navBar "
        aria-label="Sixth navbar example"
      >
        <div className="container-fluid">
          <div className="d-flex" style={{ cursor: "pointer" }}>
            <img src={logo} width="180" height="130%" className="ms-2"></img>
          </div>
          <div className="" id="navbarsExample06">
            <div className="d-flex justify-content-between w-100">
              <div className="d-lg-none d-xl-block"></div>

              <div className="d-flex justify-content-center ">
                <div className="me-3 pt-2">
                  <p className="welcome">
                    <span className="">Hello, </span>
                    {userdata?.user_name}
                  </p>
                </div>

                {!window.location.pathname.includes("support") && (
                  <div className="me-3">
                    <button
                      className="btn supportbtn"
                      onClick={() => {
                        navigate("/support");
                      }}
                    >
                      Help
                    </button>
                  </div>
                )}

                {/* {notifications?.length === 0 ? ( */}
                <IconButton
                  onClick={handleClick}
                  style={{
                    height: "fit-content",
                    color:
                      notifications.filter(
                        (notification) => notification?.is_read === false
                      ).length === 0
                        ? "lightgray"
                        : "rgb(245, 174, 65)",
                  }}
                >
                  <Badge
                    badgeContent={
                      notifications.filter(
                        (notification) => notification.is_read === false
                      ).length
                    } // Replace with your actual notifications array
                    color="error"
                    overlap="circular"
                  >
                    <NotificationsActiveIcon fontSize="" />
                  </Badge>
                </IconButton>
                <Tooltip
                  placement="bottom"
                  title={
                    <>
                      <div>Refresh Projects</div>
                      <div> {getLastRefreshTime()}</div>
                    </>
                  }
                >
                  <IconButton
                    onClick={handleReload}
                    style={{ height: "fit-content", color: "#171A1F" }}
                    className="me-2"
                  >
                    <Badge
                      // badgeContent={
                      //   notifications.filter(
                      //     (notification) => notification.is_read === false
                      //   ).length
                      // } // Replace with your actual notifications array
                      color="error"
                      overlap="circular"
                    >
                      <img
                        src={refresh}
                        style={{ width: "23px", height: "23px" }}
                        alt="refresh_icon"
                      />
                    </Badge>
                  </IconButton>
                </Tooltip>

                <div className="">
                  <ul
                    className="navbar-nav  me-3"
                    style={{ cursor: "pointer" }}
                  >
                    <li className="nav-item dropdown ms-auto ">
                      <a
                        className="nav-link "
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="fa-solid fa-bars barsnav"></i>
                      </a>
                      <div
                        className="dropdown-menu  dropdown-menu-end animated zoomIn position-absolute"
                        aria-labelledby="navbarDropdown"
                      >
                        {userdata?.role !== "Admin" &&
                        userdata?.role !== "Inspector" ? (
                          <>
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                navigate("/account");
                              }}
                            >
                              Account Information
                            </a>{" "}
                            <div className="dropdown-divider"></div>
                          </>
                        ) : null}

                        <a
                          className="dropdown-item"
                          onClick={() => {
                            handleLogout();
                          }}
                        >
                          Logout
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <Outlet />

      {/* Notification popover */}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ borderRadius: "12px", boxShadow: 3 }}
      >
        <Box sx={{ width: 350, overflowY: "auto", p: 0 }}>
          {/* Sticky Header */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              backgroundColor: "#fff",
              zIndex: 1,
              // px: 2,
              py: 1.5,
              borderBottom: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 500 }}
              className="ps-3"
            >
              Notifications
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center" }}
              className="pe-3"
            >
              <Typography
                variant="caption"
                sx={{ cursor: "pointer", color: "grey" }}
                onClick={handleClearAll}
              >
                Clear all
              </Typography>
            </Box>
          </Box>

          {/* Notification List */}
          <List sx={{ maxHeight: 300, overflowY: "auto", p: 0 }}>
            {notifications.length > 0 ? (
              notifications.map((notification) => (
                <React.Fragment key={notification.id}>
                  <ListItem
                    sx={{
                      opacity: notification.disabled ? 0.6 : 1,
                      pointerEvents: notification.disabled ? "none" : "auto",
                      cursor: notification?.is_read ? "" : "pointer",
                      padding: "12px 12px 0px 12px",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: !notification?.is_read
                        ? "aliceblue"
                        : "#fafafa",
                    }}
                    onClick={() => {
                      if (!notification.is_read) {
                        notificationRead(notification.id);
                        handleNotificationClick(notification);
                      }
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item sm={1}>
                        <ListItemIcon sx={{ minWidth: 20 }}>
                          {/* <CircleNotificationsIcon /> */}
                          {/* <InfoIcon /> */}
                          {getIcon(notification.title, notification?.is_read)}
                        </ListItemIcon>
                      </Grid>
                      <Grid item sm={11} className="pt-1">
                        <ListItemText
                          className="ms-2"
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 500,
                                fontSize: 14,
                                color: !notification.is_read
                                  ? "inherit"
                                  : "gray",
                                display: "-webkit-box",
                                WebkitLineClamp: 2, // Limit to 2 lines
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                            >
                              {notification.title}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2, // Limit to 2 lines
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  color: !notification.is_read
                                    ? "inherit"
                                    : "#afaaaa",
                                }}
                              >
                                {notification.message}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{
                                  color: !notification.is_read
                                    ? "inherit"
                                    : "#afaaaa",
                                  paddingTop: "5px",
                                }}
                              >
                                {getRelativeTime(notification.created_at)}
                              </Typography>
                            </>
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider className="ms-2 me-2" sx={{ color: "grey" }} />
                </React.Fragment>
              ))
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 150,
                  p: 2,
                  textAlign: "center",
                }}
              >
                <InboxIcon style={{ fontSize: 40, color: "#999" }} />
                <Typography sx={{ fontSize: "0.87rem", color: "#999", mt: 1 }}>
                  No Notifications Found
                </Typography>
              </Box>
            )}
          </List>
        </Box>
      </Popover>
    </>
  );
}

export default NavBar;
